import React, { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { FormButton } from "@/components/Form";
import ResultGlass, { ResultType, SharingType } from "@/components/ResultGlass";
import { GlobalContext } from "@/contexts";
import LocaleContext from "@/i18n";
import { handleShare } from "@/utils/socialActions";

type QuizSummaryProps = {
  icons: IIcons;
  userVoteCount: number;
  totalVoteCount: number;
  showDetails: boolean;
  sharingTitle: string;
  hasOutro: boolean;
  onRetry: () => void;
  onLoad: () => void;
};

export const QuizSummary: React.FC<QuizSummaryProps> = (
  props: QuizSummaryProps
): JSX.Element => {
  const [showResult, setShowResult] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(true);

  const globalContext = useContext(GlobalContext);
  const localeContext = useContext(LocaleContext);

  const {
    userVoteCount,
    totalVoteCount,
    onRetry,
    sharingTitle,
    showDetails,
    icons,
    onLoad,
    hasOutro,
  } = props;

  useEffect(() => {
    setTimeout(() => onLoad(), 4000);
    setTimeout(() => setDisableButton(false), hasOutro ? 4800 : 1500);
    setTimeout(() => setShowResult(true), 1000);
  }, []);

  const hasNotAllCorrectAnswers = userVoteCount !== totalVoteCount;

  const handleShareClick = useCallback((type: SharingType) => {
    handleShare(type, sharingTitle, globalContext.brandSettings?.xHandle);
  }, []);

  return (
    <SummaryContent>
      {showResult && (
        <SummaryBox>
          <ResultGlass
            type={ResultType.count}
            resultText={localeContext.translation.quizSummary.resultText}
            onShareClick={handleShareClick}
            showDetails={showDetails}
            icons={icons}
            userVoteCount={userVoteCount}
            totalVoteCount={totalVoteCount}
          />
        </SummaryBox>
      )}
      {showResult && hasNotAllCorrectAnswers && (
        <FormButton
          type="button"
          label={localeContext.translation.tryAgain}
          disabled={disableButton}
          onClick={onRetry}
        />
      )}
    </SummaryContent>
  );
};

const SummaryContent = styled.div`
  min-height: 341px;
  width: 90%;
  margin: 0 auto;
`;

const SummaryBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
